<template>
    <div class="xc-modal xc-modal-page">
        <div class="xc-modal-mask"></div>
        <div class="xc-modal-wrap">
            <div class="xc-modal-content">
                <div class="xc-modal-header">
                    <div class="xc-modal-title">监播数据</div>
                    <div
                        class="xc-modal-close"
                        @click="layerClose"
                    ></div>
                </div>
                <div class="xc-modal-body">
                    <div class="xc-info">
                        <div class="xc-info-content">
                            <div class="xc-info-row">
                                <div class="xc-info-item">
                                    节目名称：{{programName}},共{{staticInfo.sourceCount}}个广告素材
                                </div>
                            </div>
                            <div class="xc-info-row">
                                <div class="xc-info-item">
                                    投放信息：共{{staticInfo.deviceGroupCount}}个分组,{{staticInfo.deviceCount}}个终端
                                </div>
                                <div class="xc-info-item">
                                    投放开始时间：{{staticInfo.putinStartTime}}
                                </div>
                                <div class="xc-info-item">
                                    投放结束时间：{{staticInfo.putinEndTime}}
                                </div>
                            </div>
                            <div class="xc-info-row">
                                <div class="xc-info-item">
                                    累计播放时长：{{getDuration.hours}}小时{{getDuration.minutes}}分钟{{getDuration.seconds}}秒
                                </div>
                                <div class="xc-info-item">
                                    累计播放次数：{{echart.programPlayNumAll}}次
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="myEcharts">
                        <div id="echarts">

                        </div>
                    </div>
                </div>
                <div class="xc-modal-footer xc-flex-center">
                    <div class="xc-btn-group">
                        <button
                            class="xc-btn xc-btn-primary"
                            @click="layerClose"
                        >关闭</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import echarts from "@/libs/echarts"
    import program from "@/api/program"
    export default {
        name: "ReportList",
        data(){
            return{
                staticInfo:{},
                echart:{},
                districtList:[],
                adminPath: this.$config.adminPath,
                programVersion:this.$route.params.programVersion,
                programName:this.$route.query.programName,
            }
        },
        computed:{
            getDuration(){
                var obj={
                    seconds:0,
                    minutes:0,
                    hours:0
                };
                if(this.echart && this.echart.programDurationAll){
                    var duration=this.echart.programDurationAll/1000;//毫秒转化为秒
                    if(duration>0){
                        if(duration<60){
                            obj.seconds=duration;
                        }else {
                            obj.minutes=parseInt(duration / 60);
                            obj.seconds=parseInt(duration % 60);
                            if(obj.minutes>=60){
                                obj.hours=parseInt(obj.minutes / 60);
                                obj.minutes=parseInt(obj.minutes % 60);
                            }
                        }
                    }
                }
                return obj;
            },
        },
        methods:{
            layerClose() {
                var index = parent.layer.getFrameIndex(window.name);
                parent.layer.close(index);
            },
        },
        mounted(){
            var _this=this;
            var obj={
                programVersion: _this.programVersion
            };
        //    请求统计信息
            program.getStatisticsInfo(obj).then(function (success) {
               _this.staticInfo=success.data;
            })

        //    请求报表
            program.getEchart(obj).then(function (success) {
                _this.echart=success.data;
                var myChart=echarts.init(document.getElementById("echarts"));
                _this.$nextTick(function () {
                    // 绘制图表
                    myChart.setOption({
                        title: {
                            text: '近7天平均每天曝光次数',
                            x:"center",
                            textStyle:{
                                fontSize:"18",
                                color:"#6e7a90"
                            }
                        },
                        tooltip: {
                            // show:false,
                        },
                        dataset:
                            {
                                dimensions: ["time", "programPlayNum"],
                                source: _this.echart.exposureNum.reverse()
                            },
                        xAxis: {
                            // name:"日期",
                            type:"category",
                            boundaryGap:true,
                            // data: ["3-15","3-16","3-17","3-18","3-19","3-20","3-21",],
                            //坐标轴线
                            axisLine:{
                                lineStyle:{
                                    color:"#d8e1f2",
                                    // width:5,
                                }
                            },
                            //    坐标轴刻度
                            axisTick:{
                                show:false
                            },
                            //    刻度标签
                            axisLabel:{
                                // show:false,
                                color:"#6e7a90"
                            }
                        },
                        yAxis: {
                            axisLine:{
                                show:false,
                                lineStyle:{
                                    // color:"red"
                                }
                            },
                            axisTick:{
                                show:false
                            },
                            //    刻度标签
                            axisLabel:{
                                color:"#6e7a90",
                                fontsize:14,
                            },
                            //分隔线
                            splitLine:{
                                lineStyle:{
                                    color:"#d8e1f2"
                                }
                            },
                        },
                        series: [{
                            name: '曝光次数',
                            encode:{
                                y:"programPlayNum"
                            },
                            type: 'bar',
                            label:{
                                // show:true
                            },
                            itemStyle:{
                                color:"#37cccc",
                                barBorderRadius:4
                            },
                            barWidth:10,
                        }]
                    });
                })
            })
        }
    }
</script>

<style scoped lang="scss">
    #echarts{
        width: 100%;
        height: 324px;
        border: solid 1px #eef2f9;
        padding-top: 20px;
    }
</style>
